import { Component, OnInit, HostListener } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { PdfService } from '../pdf.service';
import { PaymentService } from '../payment.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
})
export class InvoiceComponent {
  invoiceObj: any;
  header;
  datename;
  date = new Date();
  country;
  msg;
  region;
  state;
  city;
  dateFormat;
  loader:boolean=false;
  PayCost;
  payId;
  id;
  discountAmt;
  couponId;
  allPay:boolean;
  paymentValues:any;
  payPal:any;
  bank:any;
  squareUp:any;
  minus:boolean=false;
  payminus:boolean=false;
  packname;
  packInd;
  requestId;
  constructor(private service: ApiService, private handler: HandlerService, public pdf: PdfService, private router: Router, public auth: AuthService) { }

  ionViewWillEnter() {
    this.pdf.loader=true;
    this.dateFormat = this.auth.getDateformat();
    let url = window.location.href;
    this.id = url.split("/").pop();
    this.requestId = sessionStorage.getItem('requestId')
    this.service.getInvoiceById(this.id).subscribe((res: any) => {
      this.pdf.loader=false;
      if (res) {
        this.invoiceObj = res;
        if(this.invoiceObj.billPeriodEndDate){
          let x:any = new Date(this.invoiceObj.billPeriodStartDate).getFullYear();
          let y:any = new Date(this.invoiceObj.billPeriodStartDate).getMonth()+1;
          sessionStorage.setItem('year',x)
          sessionStorage.setItem('month',y)
        }
        if(this.invoiceObj.payTotalStr){
          sessionStorage.setItem('PayCost',this.invoiceObj.payTotalStr)
        }
        // console.log()
        this.payId = this.id;
        if(!res.ipay){
        this.minus=false;
        this.PayCost = res.payTotal;
        localStorage.setItem('billerMob',res.payer.contactNbrMob)
        }
        if(res.ipay){
        this.minus=true;
        this.PayCost=Math.abs(0-res.payTotal)
        localStorage.setItem('billerMob',res.biller.contactNbrMob)
        }
        if(res.payTotalStr.includes('-')){
         this.payminus=true;
        }else{
          this.payminus=false;
        }
        this.paymentValue();
        if(res.subscriptionInd==true){
          this.packname = res.serviceRequests[0].providerService.name;
        this.subService(res.serviceRequests[0].packageId)
        }else{
          this.packname = res.serviceRequests[0].providerService.name;
         
        }
        if(res.serviceRequests.length>0){
          this.couponId = res.serviceRequests[0].id;
          this.packInd =  res.serviceRequests[0].providerService.packageInd
          }
      }
      
    },
      err => {
        this.handler.res(err.error);
        this.pdf.loader=false;
      })
    if (url.includes("invoice")) {
      this.header = "CUSTOMER INVOICE";
      this.datename = "Due Date";

    }
    else {
      this.header = "CUSTOMER RECEIPT";
      this.datename = "Payment Date";
    }
    
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {   
    this.router.navigate(['/bookservice1'])  
  }

  generatePdf() {
    Object.assign(this.invoiceObj,{subheader:"INVOICE #:",notes:this.msg})
  if(this.invoiceObj.type==1)
    Object.assign(this.invoiceObj,{header:"CUSTOMER-INVOICE"})
  else{
  Object.assign(this.invoiceObj,{header:"SETTLEMENT-INVOICE"})
   if(this.invoiceObj.paymentStatus==1)
   Object.assign(this.invoiceObj,{status:"Pending"})
   if(this.invoiceObj.paymentStatus==2)
   Object.assign(this.invoiceObj,{status:"Paid"})
  }
  this.pdf.generatePdf(this.invoiceObj);  
  }
  // async routeToPayment(){
  //   this.pdf.loader=true;
  //   if(this.PayCost!=0){
  //   let z:any = await this.service.getPaymentInvoices(this.payId).toPromise()
  //   let y = z.find(res => { return res.paymentMode == 2 });
  //   if( y && y.accountNbr != " "){
  //   sessionStorage.setItem('payee',y.accountNbr);
  //   sessionStorage.setItem('pay', this.PayCost);
  //   sessionStorage.setItem('serviceId', this.payId);
  //   this.router.navigate(['/payment/' + this.payId]);
  //   }
  //   else{
  //     this.pdf.loader=false;
  //     this.handler.error('Payment Account Not Mapped. Please contact Org Admin')
  //   }
  // }

  

  // }
  pay(){
    this.router.navigate(['/review-invoice/' + this.id])
  }
  details(){
    this.router.navigate(['/asso-service/'+ this.id])
  }

  applyDiscount(){
    this.pdf.loader = true;
    let post = { 
      applyDiscount : this.discountAmt,
    }
    this.service.applyDiscount(this.couponId, this.discountAmt,post).subscribe(res => {
      this.ionViewWillEnter();
      this.discountAmt = undefined;
    },
      err => {
        this.pdf.loader = false;
        this.handler.err(err)
      })

  }
  paymentValue(){
    if(this.PayCost!=0)
    this.service.getPaymentInvoices(this.payId).subscribe((res:any)=>{
      if(res){
      this.paymentValues=res;
      this.payPal=this.paymentValues.find(res => {return res.paymentMode == 2})
      this.squareUp=this.paymentValues.find(res => {return res.paymentMode == 5})
      this.bank=this.paymentValues.find(res => {return res.paymentMode == 4})
      }
    })
  }


  completePayment(){
    var post = {
    cost:sessionStorage.getItem('pay'),
    paymentMode:2,
    paymentRcvdBy: localStorage.getItem("currentUserId")
  }
 this.service.postPaymentForPurchaseAdd(this.payId,post).subscribe(res=>{
   this.handler.res('Ad Service Purchased SuccessFully');
   this.pdf.loader=false;
   sessionStorage.clear();
   this.router.navigate(['/admin-invoice/']);
 },err=>{
   this.loader=false;
   this.handler.err(err)
 })
}


async routeToPayment(id){
  if(this.PayCost!=0){
    if(id==1){
      sessionStorage.setItem('payee',this.payPal.accountNbr);
      sessionStorage.setItem('pay', this.PayCost);
      sessionStorage.setItem('serviceId', this.id);
      this.router.navigate(['/payment/' + this.id]);
      } if(id==2){
       sessionStorage.setItem('applicationId',this.squareUp.accountName);
       sessionStorage.setItem('locationId' , this.squareUp.branch);
      sessionStorage.setItem('pay', this.PayCost);
      sessionStorage.setItem('serviceId', this.id);
      this.router.navigate(['/squareup/' + this.id]);
      }if(id==3){
       sessionStorage.setItem('pay', this.PayCost);
       sessionStorage.setItem('serviceId', this.id);
       this.router.navigate(['/bank/' + this.id]);
       sessionStorage.setItem('invoice','true')
      }
  }else{
    this.completePayment();
  }

}

splitvalue(data){
  if(data.includes('-')){
    let y =data.slice(1)
    return y;
  } else{
    return data;
  }
}
ionViewWillLeave(){
  this.allPay=false;
}
subService(id){
 
  this.service.getPackageByInvoice(id).subscribe((res:any) =>{
   
   this.packname = res[0].providerService.name
  })
}

payment(){
  if(this.invoiceObj.subscriptionInd==false){
    this.router.navigate(['order-payment/'])
  }else{
    this.router.navigate(['sub-pay/',this.requestId])
  }
}
}
